import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ShareIcon from "@mui/icons-material/Share";
import {
  Alert,
  Box,
  Button,
  IconButton,
  Snackbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CustomGreenSixPointStarIcon } from "../CustomIcons";
import { LoadingIcon } from "../StyledComponents";

const DesktopHeader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      p: 2,
    }}
  >
    <Typography
      variant="h6"
      noWrap
      component={Link}
      to="/"
      sx={{
        fontWeight: 400,
        color: "inherit",
        textDecoration: "none",
        fontSize: { xs: "1rem", md: "1.5rem" },
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <Box component="span" sx={{ color: "#FF3B30" }}>
        smooth
      </Box>
      <Box component="span" sx={{ color: "#FFFFFF" }}>
        speak
      </Box>
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          backgroundColor: "#1C1C1E",
          padding: "8px 16px",
          borderRadius: "20px",
        }}
      >
        <a
          href="https://www.tiktok.com/@smoothspeakai"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36c17f1b729091ca1277_8547041_tiktok_icon%20(1).svg"
            alt="TikTok"
            style={{ width: "24px", height: "24px" }}
          />
        </a>
        <a
          href="https://www.instagram.com/smoothspeakai/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36920a51536aef34fa9b_5335781_camera_instagram_social%20media_instagram%20logo_icon.svg"
            alt="Instagram"
            style={{ width: "24px", height: "24px" }}
          />
        </a>
        <Typography
          sx={{
            fontSize: "0.9rem",
            color: "#666",
            marginLeft: 1,
          }}
        >
          Join{" "}
          <span style={{ color: "#00A67E", fontWeight: "bold" }}>1000+</span>{" "}
          users now
        </Typography>
      </Box>
    </Box>
    <Button
      variant="outlined"
      component={Link}
      to="/signup"
      sx={{
        color: "#FF3B30",
        borderColor: "#FF3B30",
        fontSize: { xs: "0.75rem", md: "1rem" },
        textTransform: "none",
        animation: "2s infinite pulse",
        "@keyframes pulse": {
          "0%": {
            boxShadow: "0 0 0 0 rgba(255, 59, 48, 1)",
          },
          "70%": {
            boxShadow: "0 0 0 10px rgba(255, 59, 48, 0)",
          },
          "100%": {
            boxShadow: "0 0 0 50px rgba(255, 59, 48, 0)",
          },
        },
        "&:hover": {
          borderColor: "#FF3B30",
          backgroundColor: "rgba(255, 59, 48, 0.04)",
        },
      }}
    >
      Sign Up for Free
    </Button>
  </Box>
);

const MobileHeader = () => (
  <Box sx={{ width: "100%", p: 2 }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        mb: 2,
      }}
    >
      <Typography
        variant="h4"
        noWrap
        component={Link}
        to="/"
        sx={{
          fontWeight: 400,
          color: "inherit",
          textDecoration: "none",
          fontSize: "1rem",
          "&:hover": {
            opacity: 0.8,
          },
        }}
      >
        <Box component="span" sx={{ color: "#FF3B30" }}>
          smooth
        </Box>
        <Box component="span" sx={{ color: "#FFFFFF" }}>
          speak
        </Box>
      </Typography>

      <Button
        variant="outlined"
        component={Link}
        to="/signup"
        sx={{
          color: "#FF3B30",
          borderColor: "#FF3B30",
          fontSize: "0.75rem",
          textTransform: "none",
          animation: "2s infinite pulse",
          "@keyframes pulse": {
            "0%": {
              boxShadow: "0 0 0 0 rgba(255, 59, 48, 1)",
            },
            "70%": {
              boxShadow: "0 0 0 10px rgba(255, 59, 48, 0)",
            },
            "100%": {
              boxShadow: "0 0 0 50px rgba(255, 59, 48, 0)",
            },
          },
          "&:hover": {
            borderColor: "#FF3B30",
            backgroundColor: "rgba(255, 59, 48, 0.04)",
          },
        }}
      >
        Sign Up for Free
      </Button>
    </Box>

    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          backgroundColor: "#1C1C1E",
          padding: "8px 16px",
          borderRadius: "20px",
        }}
      >
        <a
          href="https://www.tiktok.com/@smoothspeakai"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36c17f1b729091ca1277_8547041_tiktok_icon%20(1).svg"
            alt="TikTok"
            style={{ width: "20px", height: "20px" }}
          />
        </a>
        <a
          href="https://www.instagram.com/smoothspeakai/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36920a51536aef34fa9b_5335781_camera_instagram_social%20media_instagram%20logo_icon.svg"
            alt="Instagram"
            style={{ width: "20px", height: "20px" }}
          />
        </a>
        <Typography
          sx={{
            fontSize: "0.7rem",
            color: "#666",
            marginLeft: 1,
          }}
        >
          Join{" "}
          <span style={{ color: "#00A67E", fontWeight: "bold" }}>1000+</span>{" "}
          users now
        </Typography>
      </Box>
    </Box>
  </Box>
);

const ExpandedTextActivity = ({ isSharedView = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { id } = useParams(); // Get ID from URL params

  const [isLoading, setIsLoading] = useState(true);
  const [isSharing, setIsSharing] = useState(false);
  const [activity, setActivity] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const endpoint = isSharedView
          ? `/api/roleplay/text_activity/share`
          : `/api/irl/text_activity`;

        const params = isSharedView ? { share_id: id } : { id };

        const { data } = await axios.get(endpoint, { params });
        setActivity(data);
      } catch (error) {
        console.error("Error fetching activity:", error);
        setSnackbar({
          open: true,
          message: "Failed to load activity",
          severity: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchActivity();
  }, [id, isSharedView]);

  const handleShare = async () => {
    try {
      setIsSharing(true);
      const shareUrl = window.location.href; // Use current page URL
      const shareText =
        "Hey! Sharing what Smoothspeak suggested for me for these screenshots. Smoothspeak is an AI texting wingman that tells you what to say on dating apps, text and socials. It's completely free!";

      // Only use native share on mobile devices
      if (isMobile && navigator.share) {
        try {
          await navigator.share({
            title: "Tap to see my 🔥 Smoothspeak suggestions",
            text: shareText,
            url: shareUrl,
          });

          // Only show success message if share was completed
          setSnackbar({
            open: true,
            message: "Shared successfully!",
            severity: "success",
          });
        } catch (shareError) {
          // Only fallback to clipboard if it's not a user abort
          if (shareError.name !== "AbortError") {
            await navigator.clipboard.writeText(`${shareText}\n\n${shareUrl}`);
            setSnackbar({
              open: true,
              message: "Share link copied to clipboard!",
              severity: "success",
            });
          }
        }
      } else {
        // Desktop or non-sharing devices - use clipboard directly
        await navigator.clipboard.writeText(`${shareText}\n\n${shareUrl}`);
        setSnackbar({
          open: true,
          message: "Share link copied to clipboard!",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error sharing:", error);
      setSnackbar({
        open: true,
        message: "Failed to share. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSharing(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    if (activity.images && currentImageIndex < activity.images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (activity.images && currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingIcon width={48} height={48} />
      </Box>
    );
  }

  if (!activity) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>Activity not found</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        pr: isMobile ? 0 : 5,
        pl: isMobile ? 0 : 5,
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#000000",
        overflowX: "hidden",
      }}
    >
      {isSharedView && (isMobile ? <MobileHeader /> : <DesktopHeader />)}

      <Box
        sx={{
          width: "100%",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <Box
          sx={{
            width: "100%",
            background: "#000000",
            borderRadius: "12px",
            padding: isMobile ? 0 : "20px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {/* Left Side - Images */}
          <Box
            sx={{
              flex: isMobile ? "none" : 1,
              p: isMobile ? 0 : 3,
              borderRight: isMobile ? "none" : "1px solid #1C1C1E",
              borderBottom: isMobile ? "1px solid #1C1C1E" : "none",
            }}
          >
            {/* Add Share Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: 1,
                pt: isMobile ? 1 : 0,
              }}
            >
              <Button
                variant="contained"
                onClick={handleShare}
                disabled={isSharing}
                startIcon={<ShareIcon sx={{ fontSize: isMobile ? 20 : 24 }} />}
                sx={{
                  backgroundColor: "#FF3B30",
                  color: "white",
                  textTransform: "none",
                  fontSize: isMobile ? "1rem" : "1.1rem",
                  padding: isMobile ? "12px 24px" : "12px 32px",
                  "&:hover": { backgroundColor: "#E63529" },
                  "&:disabled": { backgroundColor: "#2C2C2E" },
                  borderRadius: "12px",
                }}
              >
                {isSharing ? "Sharing..." : "Share"}
              </Button>
            </Box>

            {/* Image Carousel */}
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: isMobile ? "calc(100vh - 200px)" : "auto",
                maxWidth: "100vw",
                overflow: "hidden",
              }}
            >
              {activity.images?.length > 1 && currentImageIndex > 0 && (
                <IconButton
                  onClick={handlePrevImage}
                  sx={{
                    position: "absolute",
                    left: 0,
                    zIndex: 2,
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: isMobile ? "90%" : "65%",
                  height: "100%",
                  position: "relative",
                }}
              >
                <img
                  src={activity.images?.[currentImageIndex]}
                  alt={`Screenshot ${currentImageIndex + 1}`}
                  style={{
                    width: "auto",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: isMobile ? 0 : "8px",
                    maxWidth: "100%",
                  }}
                />
              </Box>

              {activity.images?.length > 1 &&
                currentImageIndex < activity.images.length - 1 && (
                  <IconButton
                    onClick={handleNextImage}
                    sx={{
                      position: "absolute",
                      right: 0,
                      zIndex: 2,
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                      },
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                )}
            </Box>

            {/* Image Navigation Dots */}
            {activity.images?.length > 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                  mt: 2,
                }}
              >
                {activity.images.map((_, index) => (
                  <Box
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor:
                        currentImageIndex === index ? "#4CAF50" : "#E0E0E0",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                    }}
                  />
                ))}
              </Box>
            )}
          </Box>

          {/* Right Side - AI Suggestions */}
          <Box
            sx={{
              flex: isMobile ? "none" : 1,
              bgcolor: "#000000",
              borderRadius: isMobile ? 0 : "0 12px 12px 0",
              width: "100%",
              pb: isMobile ? 8 : 0,
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 3,
                pb: 2,
                borderBottom: "1px solid #1C1C1E",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CustomGreenSixPointStarIcon
                  sx={{ mr: 1, fontSize: isMobile ? 24 : 30 }}
                />
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontSize: isMobile ? "18px" : "24px",
                    fontWeight: 500,
                    fontFamily: "Unbounded, sans-serif",
                  }}
                >
                  AI Suggestions
                </Typography>
              </Box>
            </Box>

            {/* Content */}
            <Box
              sx={{
                p: 3,
                pt: 2,
                pb: isMobile ? 6 : 3,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                {activity.messages?.map((suggestion, index) => (
                  <Box
                    key={index}
                    sx={{
                      p: 3,
                      mb: 2,
                      bgcolor: "#1C1C1E",
                      borderRadius: "12px",
                      boxShadow: "0px 2px 4px rgba(255, 255, 255, 0.05)",
                      border: "1px solid #2C2C2E",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: "0px 4px 8px rgba(255, 255, 255, 0.1)",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontFamily: "Unbounded, sans-serif",
                        fontSize: "18px",
                      }}
                    >
                      {suggestion}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Share Link Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ExpandedTextActivity;
